<div class="confirmation-dialog">
  <div class="mb-3 w-100 h-fit d-flex justify-content-end">
    <img (click)="close()" class="cursor-pointer" src="assets/icons/close.svg" alt="">
  </div>
  <h1 class="text-24-600-133 text-c4 text-center">{{'Are you sure you want to logout?'| translate}}</h1>
  <!-- <h1 *ngIf="qnCompleted" class="text-24-600-133 text-c4 text-center">{{'All levels completed!'| translate}}</h1> -->
  <!-- <div>
    <p class="text-12-400-183 text-center">Please note down your username and password for future reference before
      logging out.</p>
    <div class="profile-credentials d-flex gap-4 justify-content-center">
      <div class="d-flex flex-column gap-1 justify-content-between">
        <span class="text-12-400-183 text-c2">{{'Username'| translate}}</span>
        <span class="text-12-400-183 text-c2">{{'Password'|translate}}</span>
      </div>
      <div class="d-flex flex-column gap-1 justify-content-between">
        <span class="text-12-400-183 text-c4">{{'userDetails?.username'}}</span>
        <span class="text-12-400-183 text-c4">{{'userDetails?.password'}}</span>
      </div>
    </div>
  </div> -->
  <div class="d-flex gap-5 logout-btns">
    <button (click)="close()"
      class="mt-4 primary-btn text-14-600-171 w-100 d-flex align-items-center justify-content-center">{{'Cancel' | translate}}</button>
    <button (click)="close(true)"
      class="mt-4 secondary-btn text-14-600-171 w-100 d-flex align-items-center justify-content-center">{{'Logout' | translate}}</button>
  </div>
</div>
